import { pgTable, text, unique, uuid, integer, foreignKey, } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from '../org-id';
import { relations } from 'drizzle-orm';
import { Org } from '../org';
import { Profile } from '../profile';
import { AthletePublishedWorkoutLayer } from '../block/workout';
import { TaskStatus } from '../../enums';
export const AmsClassicOrgConfig = pgTable('ams_classic_org_config', {
    ...orgTableBase,
    amsClassicSiteUrl: text('ams_classic_site_url').notNull(),
    amsClassicUsername: text('ams_classic_username').notNull(),
    amsClassicEncryptedPassword: text('ams_classic_encrypted_password').notNull(),
    /**
     * AMS Cricket form id; used as `subjectIds` when registering webhooks.
     * Tells us that the org has enabled Cricket sync and which form id to use.
     */
    amsCricketFormId: integer('ams_cricket_form_id'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    orgUq: unique().on(table.orgId),
}));
export const AmsClassicOrgConfig_Relations = relations(AmsClassicOrgConfig, ({ one }) => ({
    org: one(Org, {
        fields: [AmsClassicOrgConfig.orgId],
        references: [Org.id],
    }),
}));
export const AmsClassicUser = pgTable('ams_classic_user', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    amsClassicUserId: integer('ams_classic_user_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    amsClassicUserUq: unique().on(table.orgId, table.amsClassicUserId),
    athleteFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const AmsClassicWorkout = pgTable('ams_classic_workout', {
    ...orgTableBase,
    amsClassicEventId: integer('ams_classic_event_id').notNull(),
    blockId: uuid('block_id').notNull(),
    profileId: uuid('profile_id').notNull(),
    workoutId: uuid('workout_id').notNull(),
    version: integer('version').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    amsClassicEventUq: unique().on(table.orgId, table.amsClassicEventId),
    profileWorkoutUq: unique().on(table.orgId, table.profileId, table.workoutId),
    athleteFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
    workoutFk: foreignKey({
        columns: [
            table.orgId,
            table.blockId,
            table.workoutId,
            table.profileId,
            table.version,
        ],
        foreignColumns: [
            AthletePublishedWorkoutLayer.orgId,
            AthletePublishedWorkoutLayer.blockId,
            AthletePublishedWorkoutLayer.workoutId,
            AthletePublishedWorkoutLayer.profileId,
            AthletePublishedWorkoutLayer.version,
        ],
    }),
}));
export const AmsWorkoutPublishTask = pgTable('ams_workout_publish_task', {
    ...orgTableBase,
    blockId: uuid('block_id').notNull(),
    profileId: uuid('profile_id').notNull(),
    workoutId: uuid('workout_id').notNull(),
    status: TaskStatus('status').notNull(),
    blockVersion: integer('block_version').notNull(),
    version: integer('version').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.blockId, table.workoutId, table.profileId),
    athleteFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
//# sourceMappingURL=ams_classic.js.map